import mvtPicture from '@/common/components/mvtpicture/mvt-picture.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'guideWelcome',
    props: {
        article: Object,
        hub: Object,
        alt: {
            default: 'Welcome Guide Article Movoto'
        }
    },
    components: {
        mvtPicture
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide']),
        getHeroImage() {
            var im = this.article || this.hub;
            return im && (im.featuredImage || im.image);
        },
        getHeroImgWebp() {
            return this.article && this.article.featuredImageWebp;
        }
    }
};